import React, { useState, type FormEvent } from "react";
import { Center } from "@/shared/components/center/Center";
import { Stack } from "@/shared/components/stack/Stack";
import { TextField } from "@/shared/components/fields/TextField";
import { SelectField } from "@/shared/components/fields/SelectField";
import "./AddUserPage.css";
import { Logo } from "../../components/logo/Logo";
import { createManager } from "../../api/createManager";
import { toast } from "sonner";

export const AddUserPage = () => {
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);

    const formData = new FormData(e.currentTarget);

    const email = formData.get("email") as string;
    const fullName = formData.get("fullName") as string;
    const role = formData.get("role") as string;

    const [name, ...surnameParts] = fullName.trim().split(" ");
    const surname = surnameParts.join(" ") || "";

    try {
      await createManager({
        login: email,
        name: name as string,
        surname: surname,
        role: role,
        password: "",
      });

      alert("Менеджер успешно создан!");
    } catch (error) {
      const message =
      error instanceof Error
        ? error.message
        : "Не удалось добавить пользователя";
    toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pageContainer">
      <Center>
        <div className="card">
          <Stack gap={"32px"}>
            <Center>
              <Stack
                gap={"24px"}
                style={{ alignItems: "center", textAlign: "center" }}
              >
                <Logo />
                <Stack gap={"8px"}>
                  <h1 className="title">Добавить пользователя</h1>
                  <p className="subtitle">
                    Пользователь получит доступ к системе
                  </p>
                </Stack>
              </Stack>
            </Center>

            <form onSubmit={handleSubmit}>
              <Stack gap={"24px"}>
                <Stack gap={"16px"}>
                  <TextField
                    label="Email"
                    type="email"
                    name="email"
                    placeholder="ABC@mail.kz"
                    required
                  />

                  <TextField
                    label="Имя и Фамилия"
                    type="text"
                    name="fullName"
                    placeholder="Айгерим Амиркан"
                    required
                  />

                  <SelectField
                    label="Роль в системе"
                    name="role"
                    defaultValue="admin"
                    options={[
                      { value: "admin", label: "Администратор" },
                      { value: "manager", label: "Менеджер" },
                      { value: "viewer", label: "Наблюдатель" },
                    ]}
                  />
                </Stack>

                <Stack gap={"12px"}>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className='submitButton'
                  >
                    {isLoading ? "Загрузка..." : "Пригласить"}
                  </button>

                  <button type="button" className="cancelButton">
                    Отмена
                  </button>
                </Stack>
              </Stack>
            </form>
          </Stack>
        </div>
      </Center>
    </div>
  );
};
